import RpmDataModal from "./RpmDataModal";

export default  RpmDataModal;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/index.js